import React, { useState, useEffect } from "react";
import "../../../assests/css/Verda/varda-form.css";
import "../../../assests/css/Verda/bootstrap.min.css";
import "../../../assests/css/Verda/my-style.css";
import * as DateUtil from "../../../Utils/DatePicker";
import { handleDateChange } from "../../../Utils/DateFormatter";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import { getVerdaPdf } from "../../../Redux/Actions/verdaAction";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

export const VerdaCoordinationForm = (props) => {
  const planYear = useSelector((plan) =>
    plan.webApp.year?.planYear ? plan.webApp.year.planYear : plan.webApp.year
  );
  let initialState = {
    firstName: "",
    lastName: "",
    middleInitial: "",
    date: "",
    dateOfBirth: "",
    phone: "",
    emergencyContact: "",
    phoneNumber: "",
    relationship: "",
    language: [],
    pcp: "",
    medicalGroup: "",
    sameMedicalGroupInd: "",
    samePcpInd: "",
    currentPCPAndMedical: "",
    immediateNeedInd: "N",
    hospitalizedInd: "N",
    treatmentInd: "N",
    surgeryInd: "N",
    equipmentInd: "N",
    equipmentType: "",
    rentalCompanyName: "",
    rentalCompanyPhone: "",
    rentalEquipments: [],
    othEquipment1: "",
    othEquipment2: "",
    medicationName1: "",
    medicationName2: "",
    medicationName3: "",
    medicationName4: "",
    medicationName5: "",
    dosage1: "",
    dosage2: "",
    dosage3: "",
    dosage4: "",
    dosage5: "",
  };
  const [state, setState] = useState(initialState);
  const [disable, setDisable] = useState(true);
  const [snackBarOpen, setSnackbarOpen] = useState(false);
  const [alertMsg, setalertMsg] = useState("");
  const [severity, setseverity] = useState("");
  const [vertical] = useState("top");
  const [horizontal] = useState("center");
  const pcpSelected = useSelector((selectedVo) => selectedVo.webApp.selectedVo);
  const physicians = useSelector(
    (physicians1) => physicians1.webApp.physiciansData
  );
  const preEnrollInfo = useSelector(
    (preEnrollInfos) => preEnrollInfos.webApp.preEnrollInfo
  );
  const dispatch = useDispatch();
  const submitHandler = async () => {
    let response = await dispatch(
      getVerdaPdf({
        planYear: planYear,
        formType: "care",
        careFormVO: {
          ...state,
          // language:state?.language.toString()
        },
        preEnrollFormVO: null,
      })
    );
    if (response.status === "OK") {
      const blob = "data:application/pdf;base64," + response.data;
      props.savePdfBlobs([
        {
          attachmentType: "COORDINATION OF CARE",
          attachment: blob,
          typeCode: "CC",
        },
      ]);
      setSnackbarOpen(true);
      setalertMsg("Submitted Successfully.");
      setseverity("success");
      props.isSubmitted({ careInd: "Y" });
      props.closeModal();
    } else {
      setSnackbarOpen(true);
      setalertMsg("System Error.");
      setseverity("error");
      props.isSubmitted({ careInd: "N" });
    }
  };
  const handleDates = (fieldId) => {
    DateUtil.getDatePicker("#" + fieldId).datepicker("show");
    DateUtil.getDatePicker("#" + fieldId).on("change", (e) => {
      setDates(fieldId, e.target.value);
      DateUtil.getDatePicker("#" + fieldId);
      //.datepicker("refresh");
    });
  };
  const setDates = async (fieldId, value) => {
    if (fieldId === "dateOfBirth") {
      if (new Date(value) > new Date()) {
        // this.setState({
        //   ...this.state,
        //   snackBarOpen: true,
        //   alertMsg: "Birth date can not be a future date.",
        //   severity: "error",
        //   data: { ...this.state.data, [fieldId]: "" },
        // });
        setSnackbarOpen(true);
        setalertMsg("Birth date can not be a future date.");
        setseverity("error");
        setState({
          ...state,
          [fieldId]: "",
        });
        return;
      }
    }
    setState({ ...state, [fieldId]: value });
  };
  const handleDate = async (event) => {
    let name = event.target.name;
    let value = event.target.value;

    value = handleDateChange(value);
    if (name === "dateOfBirth") {
      let splittedDate = value.split("/");
      if (splittedDate.length === 3 && splittedDate[2] !== "") {
        if (new Date(value) > new Date()) {
          //   this.setState({
          //     snackBarOpen: true,
          //     alertMsg: "Birth date can't be a future date.",
          //     severity: "error",
          //     data: { ...this.state.data, [name]: "" },
          //   });
          setSnackbarOpen(true);
          setalertMsg("Birth date can not be a future date.");
          setseverity("error");
          setState({
            ...state,
            [name]: "",
          });
          return;
        }
      }
    }

    if (value === "") {
      //   this.setState({
      //     snackBarOpen: true,
      //     alertMsg: "Please enter date in the MM/DD/YYYY format",
      //     severity: "error",
      //   });
      setSnackbarOpen(true);
      setalertMsg("Please enter date in the MM/DD/YYYY format");
      setseverity("error");
    }
    setState({ ...state, [name]: value });
    // await this.setState({
    //   data: { ...this.state.data, [name]: value },
    // });
  };
  const formatPhoneNumber = (phoneNumberString) => {
    let match = phoneNumberString.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return "(" + match[1] + ") " + match[2] + "-" + match[3];
    }
    return phoneNumberString;
  };
  const handleChange = async (event) => {
    event.persist();
    let name = event.target.name;
    let value = event.target.value?.trimStart().toUpperCase();
    if (name.toLowerCase().includes("phone")) {
      value = formatPhoneNumber(value.replace(/[^0-9]/g, ""));
    }
    if (name === "language") {
      let languageList = state?.language;
      //checking
      if (event.target.checked === true) {
        if (!languageList.includes(value)) {
          languageList.push(value);
        }
      }
      //unchecking
      else {
        if (languageList.includes(value)) {
          let index = languageList.indexOf(value);
          languageList.splice(index, 1);
        }
      }
      return setState({ ...state, [name]: languageList });
    }
    if (name === "rentalEquipments") {
      let equipmentList = state?.rentalEquipments;
      //checking
      if (event.target.checked === true) {
        if (!equipmentList.includes(value)) {
          equipmentList.push(value);
        }
      }
      //unchecking
      else {
        if (equipmentList.includes(value)) {
          let index = equipmentList.indexOf(value);
          equipmentList.splice(index, 1);
        }
      }
      return setState({ ...state, [name]: equipmentList });
    }
    if (
      event.target.type === "checkbox" &&
      (name == "immediateNeedInd" ||
        name === "hospitalizedInd" ||
        name === "treatmentInd" ||
        name === "surgeryInd" ||
        name === "equipmentInd")
    ) {
      value = event.target.checked === true ? "Y" : "N";
      if (name === "equipmentInd" && event.target.checked === false) {
        return setState({ ...state, [name]: value, equipmentType: "" });
      }
    }
    // if (event.target.type === "checkbox" && name == "language") {
    //   let langArray=state?.language
    //   if (event.target.checked === true) {
    //     if(langArray?.includes(value)){
    //       return setState({ ...state, [name]: langArray });
    //     }
    //     else{
    //       langArray.push(value)
    //       return setState({ ...state, [name]: langArray});
    //     }
    //   } else {
    //     //removing value from list on unchecking
    //     langArray.splice(langArray.indexOf(value),1)
    //     return setState({ ...state, [name]: langArray });
    //   }
    // }
    setState({ ...state, [name]: value });
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };
  useEffect(() => {
    let pcpPreview =
      props.pcpName !== undefined && props.pcpName !== ""
        ? props.pcpName
        : preEnrollInfo?.pcpName
        ? preEnrollInfo?.pcpName
        : props?.data?.pcpName
        ? props?.data.pcpName
        : "";
    setState({
      ...state,
      firstName: props?.data?.firstName,
      middleInitial: props?.data?.middleInitial,
      lastName: props?.data?.lastName,
      dateOfBirth: props?.data?.birthDate,
      phone: props?.data?.primaryPhoneNum,
      pcp: pcpSelected.pcpName
        ? pcpSelected.pcpName
        : // +" "+"-"+" "+pcpSelected?.PcpLocationId?.trim()+" "+"-"+" "+pcpSelected?.pcpAddress
        preEnrollInfo?.pcpName
        ? preEnrollInfo.pcpName
        : // +" "+"-"+" "+props?.PcpLocationId?.trim()+" "+"-"+" "+preEnrollInfo?.pcpDetails?.address
          "",
      medicalGroup:
        pcpPreview && props?.PcpLocationId
          ? physicians.length > 1
            ? physicians.filter(
                (data1) =>
                  data1.doctorName + " " + "-" + " " + data1?.locationId ===
                  pcpPreview + " " + "-" + " " + props?.PcpLocationId
              )[0] !== undefined
              ? physicians.filter(
                  (data1) =>
                    data1.doctorName + " " + "-" + " " + data1?.locationId ===
                    pcpPreview + " " + "-" + " " + props?.PcpLocationId
                )[0].clinicName
              : ""
            : ""
          : "",
      language: [],
      rentalEquipments: [],
    });
  }, []);
  useEffect(() => {
    // if(state?.equipmentInd ==="N"){
    //   setState({...state,equipmentType:""})
    // }
    if (
      state?.lastName === "" ||
      state?.firstName === "" ||
      state?.dateOfBirth === "" ||
      !moment(state?.dateOfBirth, "MM/DD/YYYY", true).isValid() ||
      state?.date === "" ||
      !moment(state?.date, "MM/DD/YYYY", true).isValid() ||
      state?.language?.length < 1 ||
      state?.phone?.length < 14 ||
      (state?.phoneNumber != "" && state?.phoneNumber?.length < 14) ||
      state?.pcp === "" ||
      state?.samePcpInd === "" ||
      // state?.sameMedicalGroupInd === "" ||
      state?.medicalGroup === "" ||
      // ||
      // (state?.equipmentInd === "Y" && state?.equipmentType === "")||
      // (
      //   state?.immediateNeedInd === "N" &&
      //   state?.hospitalizedInd === "N" &&
      //   state?.treatmentInd === "N" &&
      //   state?.surgeryInd === "N" &&
      //   state?.equipmentInd === "N"
      // )
      // ||((state?.sameMedicalGroupInd==="N" || state?.samePcpInd==="N")?state?.currentPCPAndMedical===""?true:false:false)
      (state?.samePcpInd === "N" && state?.currentPCPAndMedical === ""
        ? true
        : false)
    ) {
      setDisable(true);
    } else {
      setDisable(false);
    }
  }, [state]);
  return (
    <main className="page-content" id="main-content-area">
      <Snackbar
        open={snackBarOpen}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical, horizontal }}
        key={vertical + horizontal}
      >
        <Alert onClose={handleClose} severity={severity}>
          {alertMsg}
        </Alert>
      </Snackbar>
      <div className="container-fluid container-bg mt-3 mb-3">
        <div className="row">
          <div className="col-5 col-md-4">
            <img
              src={require("../../../assests/images/Verda-HPT-Hi-Res-Logo.jpg")}
              alt="Verda Healthcare logo"
              style={{ height: 130 }}
            />
          </div>
          <div className="col-7 col-md-8 text-right mt-5">
            <h4 className="page-headingNA"> Coordination of Care Form</h4>
            <h4>(required for Both Plans)</h4>
          </div>
          <div className="col-12">
            {/* <h2 className="page-subheading mb-3 text-center">
              Coordination of Care Form
            </h2> */}
          </div>
        </div>

        {/* <!-- Member Information: start --> */}
        <section>
          <h3 className="section-heading">Member Information</h3>
          <div className="row form-inline mt-2">
            <div className="col-12 col-md-9">
              <fieldset className="pb-4">
                <legend className="label-full-name">Full Name*: </legend>
                <label className="label-type1 pb-2">
                  <i className="label-name">Last</i>{" "}
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="text"
                    name="lastName"
                    value={state.lastName}
                    className="form-control form-control-sm  mr-sm-2 input-name"
                    onChange={handleChange}
                  />{" "}
                </label>
                <label className="label-type1 pb-2">
                  <i className="label-name">First</i>{" "}
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="text"
                    name="firstName"
                    value={state.firstName}
                    className="form-control form-control-sm  mr-sm-2 input-name "
                    onChange={handleChange}
                  />{" "}
                </label>
                <label className="label-type1 pb-2">
                  <i className="label-name">M.I.</i>{" "}
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="text"
                    name="middleInitial"
                    value={state.middleInitial}
                    maxLength="1"
                    className="form-control form-control-sm  mr-sm-2 input-name"
                    onChange={handleChange}
                  />{" "}
                </label>
              </fieldset>
            </div>
            <div className="col-6 col-md-3">
              <label className="label-type1">
                Date*:{" "}
                <input
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                  name="date"
                  id="date"
                  onChange={handleDate}
                  onClick={(e) => handleDates("date")}
                  value={state?.date}
                  className="form-control form-control-sm  mr-sm-2 scrollfix"
                />
              </label>
            </div>
          </div>
          <div className="row form-inline mt-3">
            <div className="col-12 col-md-5">
              <label className="label-type1">
                Date of Birth*:{" "}
                <input
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                  id="dateOfBirth"
                  name="dateOfBirth"
                  onChange={handleDate}
                  onClick={(e) => handleDates("dateOfBirth")}
                  value={state.dateOfBirth}
                  className="form-control form-control-sm  mr-sm-2 scrollfix"
                />
              </label>
            </div>
            <div className="col-12 col-md-5">
              <label className="label-type1">
                Phone*:{" "}
                <input
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                  type="text"
                  name="phone"
                  value={state?.phone}
                  onChange={handleChange}
                  maxLength="10"
                  className="form-control form-control-sm  mr-sm-2 "
                />
              </label>
            </div>
          </div>
          <div className="row form-inline mt-3">
            <div className="col-12 col-md-4">
              <label className="label-type1">
                Emergency Contact:{" "}
                <input
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                  type="text"
                  name="emergencyContact"
                  value={state?.emergencyContact}
                  onChange={handleChange}
                  className="form-control form-control-sm  mr-sm-2 input-name2"
                />
              </label>
            </div>
            <div className="col-12 col-md-4">
              <label className="label-type1">
                Phone Number:{" "}
                <input
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                  type="text"
                  name="phoneNumber"
                  value={state?.phoneNumber}
                  onChange={handleChange}
                  maxLength="10"
                  className="form-control form-control-sm  mr-sm-2 input-name2"
                />
              </label>
            </div>
            <div className="col-12 col-md-4">
              <label className="label-type1">
                Relationship:{" "}
                <input
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                  type="text"
                  name="relationship"
                  value={state?.relationship}
                  onChange={handleChange}
                  className="form-control form-control-sm  mr-sm-2 input-name2"
                />
              </label>
            </div>
          </div>
          <div className="row form-inline mt-2">
            <div className="col-md-12">
              <fieldset className="fieldset-type1 w-100 mb-4">
                <legend>Preferred Spoken Language*:</legend>
                <div className="ml-2">
                  <span className="badge badge-pill">
                    <div className="custom-control custom-checkbox custom-control-inline">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="checkbox"
                        className="custom-control-input"
                        id="english"
                        value="english"
                        name="language"
                        // disabled={
                        //   state?.language?.length > 0 &&
                        //   !state?.language?.includes("ENGLISH")
                        // }
                        onChange={handleChange}
                      />
                      <label className="custom-control-label" htmlFor="english">
                        English
                      </label>
                    </div>
                  </span>
                  <span className="badge badge-pill">
                    <div className="custom-control custom-checkbox custom-control-inline">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="checkbox"
                        className="custom-control-input"
                        id="spanish"
                        value="spanish"
                        name="language"
                        // disabled={
                        //   state?.language?.length > 0 &&
                        //   !state?.language?.includes("SPANISH")
                        // }
                        onChange={handleChange}
                      />
                      <label className="custom-control-label" htmlFor="spanish">
                        Spanish
                      </label>
                    </div>
                  </span>
                  <span className="badge badge-pill">
                    <div className="custom-control custom-checkbox custom-control-inline">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="checkbox"
                        className="custom-control-input"
                        id="cantonese"
                        value="cantonese"
                        name="language"
                        // disabled={
                        //   state?.language?.length > 0 &&
                        //   !state?.language?.includes("CANTONESE")
                        // }
                        onChange={handleChange}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="cantonese"
                      >
                        Cantonese
                      </label>
                    </div>
                  </span>
                  <span className="badge badge-pill">
                    <div className="custom-control custom-checkbox custom-control-inline">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="checkbox"
                        className="custom-control-input"
                        id="korean"
                        value="korean"
                        name="language"
                        // disabled={
                        //   state?.language?.length > 0 &&
                        //   !state?.language?.includes("KOREAN")
                        // }
                        onChange={handleChange}
                      />
                      <label className="custom-control-label" htmlFor="korean">
                        Korean
                      </label>
                    </div>
                  </span>
                  <span className="badge badge-pill">
                    <div className="custom-control custom-checkbox custom-control-inline">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="checkbox"
                        className="custom-control-input"
                        id="mandarin"
                        value="mandarin"
                        name="language"
                        // disabled={
                        //   state?.language?.length > 0 &&
                        //   !state?.language?.includes("MANDARIN")
                        // }
                        onChange={handleChange}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="mandarin"
                      >
                        Mandarin
                      </label>
                    </div>
                  </span>
                  <span className="badge badge-pill">
                    <div className="custom-control custom-checkbox custom-control-inline">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="checkbox"
                        className="custom-control-input"
                        id="tagalog"
                        value="tagalog"
                        name="language"
                        // disabled={
                        //   state?.language?.length > 0 &&
                        //   !state?.language?.includes("TAGALOG")
                        // }
                        onChange={handleChange}
                      />
                      <label className="custom-control-label" htmlFor="tagalog">
                        Tagalog
                      </label>
                    </div>
                  </span>
                  <span className="badge badge-pill">
                    <div className="custom-control custom-checkbox custom-control-inline">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="checkbox"
                        className="custom-control-input"
                        id="vietnamese"
                        value="vietnamese"
                        name="language"
                        // disabled={
                        //   state?.language?.length > 0 &&
                        //   !state?.language?.includes("VIETNAMESE")
                        // }
                        onChange={handleChange}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="vietnamese"
                      >
                        Vietnamese
                      </label>
                    </div>
                  </span>
                  <span className="badge badge-pill">
                    <div className="custom-control custom-checkbox custom-control-inline">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="checkbox"
                        className="custom-control-input"
                        id="other"
                        value="other"
                        name="language"
                        // disabled={
                        //   state?.language?.length > 0 &&
                        //   !state?.language?.includes("OTHER")
                        // }
                        onChange={handleChange}
                      />
                      <label className="custom-control-label" htmlFor="other">
                        Other
                      </label>
                    </div>
                  </span>
                </div>
              </fieldset>
            </div>
          </div>
        </section>
        {/* <!-- Member Information: end -->
       
       <!-- Primary Care Physician / Medical Group Information: start --> */}
        <section>
          <h3 className="section-heading">
            Primary Care Physician / Medical Group Information
          </h3>
          <div className="row mt-2">
            <div className="col-md-6">
              <ul className="list-group list-group-flush mr-4">
                <li className="list-group-item border-0">
                  <label className="label-type1 w-100">
                    PCP with Verda Healthcare*{" "}
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="text"
                      name="pcp"
                      value={state?.pcp}
                      onChange={handleChange}
                      className="form-control form-control-sm  mr-sm-2 w-100"
                    />
                  </label>
                </li>
                <li className="list-group-item">
                  <label className="label-type1 w-100">
                    Medical Group / IPA with Verda Healthcare*
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="text"
                      name="medicalGroup"
                      value={state?.medicalGroup}
                      onChange={handleChange}
                      className="form-control form-control-sm  mr-sm-2 w-100"
                    />
                  </label>
                </li>
              </ul>
            </div>
            <div className="col-md-6">
              <fieldset className="fieldset-type1 ml-2">
                <legend>Same PCP prior enrolling to Verda?*</legend>
                <div className="custom-control custom-checkbox custom-control-inline">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="checkbox"
                    className="custom-control-input"
                    id="same_pcp_yes"
                    name="samePcpInd"
                    value="Y"
                    checked={state?.samePcpInd === "Y"}
                    onChange={handleChange}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="same_pcp_yes"
                  >
                    Yes
                  </label>
                </div>
                <div className="custom-control custom-checkbox custom-control-inline">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="checkbox"
                    className="custom-control-input"
                    id="same_pcp_no"
                    name="samePcpInd"
                    value="N"
                    checked={state?.samePcpInd === "N"}
                    onChange={handleChange}
                  />
                  <label className="custom-control-label" htmlFor="same_pcp_no">
                    No
                  </label>
                </div>
              </fieldset>
              <fieldset className="fieldset-type1 mt-3 ml-2">
                <legend>
                  Same Medical Group / IPA prior enrolling to Verda?
                </legend>
                <div className="custom-control custom-checkbox custom-control-inline">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="checkbox"
                    className="custom-control-input"
                    id="same_medical_group_yes"
                    name="sameMedicalGroupInd"
                    value="Y"
                    checked={state?.sameMedicalGroupInd === "Y"}
                    onChange={handleChange}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="same_medical_group_yes"
                  >
                    Yes
                  </label>
                </div>
                <div className="custom-control custom-checkbox custom-control-inline">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="checkbox"
                    className="custom-control-input"
                    id="same_medical_group_no"
                    name="sameMedicalGroupInd"
                    value="N"
                    checked={state?.sameMedicalGroupInd === "N"}
                    onChange={handleChange}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="same_medical_group_no"
                  >
                    No
                  </label>
                </div>
              </fieldset>
            </div>
            <div className="col-md-12 form-inline mb-3">
              <label className="label-type1 w-100 list-group-item border-0">
                If No, who is the current PCP and Medical Group?
                {state?.samePcpInd === "N"
                  ? "*"
                  : ""}
                <input
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                  type="text"
                  name="currentPCPAndMedical"
                  value={state?.currentPCPAndMedical}
                  onChange={handleChange}
                  className="form-control form-control-sm mr-sm-2 input-name"
                />
              </label>
            </div>
          </div>
        </section>
        {/* <!-- Primary Care Physician / Medical Group Information: end --> */}

        {/* <!-- Continuity Of Care and Services:start --> */}
        <section>
          <h3 className="section-heading">Continuity Of Care and Services</h3>
          <div className="row mt-2">
            <div className="col-md-12">
              <fieldset className="fieldset-type1 w-100 mb-2">
                <legend>
                  Please let us know if you have any of the following issues
                  that apply to you, we will have a Care Coordination Team
                  member contact you to assist with the transition of services:
                </legend>
                <div className="row ml-2">
                  <div className="col-12 col-md-6">
                    <div className="custom-control custom-checkbox custom-control-inline mb-2">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="checkbox"
                        className="custom-control-input"
                        id="immediate_needs"
                        name="immediateNeedInd"
                        value="immediateNeedInd"
                        checked={state?.immediateNeedInd == "Y"}
                        onChange={handleChange}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="immediate_needs"
                      >
                        Immediate Needs – Food, Homeless, Cannot Afford
                        Medications
                      </label>
                    </div>
                    <div className="custom-control custom-checkbox custom-control-inline mb-2">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="checkbox"
                        className="custom-control-input"
                        id="currently_hospitalized"
                        name="hospitalizedInd"
                        value="hospitalizedInd"
                        checked={state?.hospitalizedInd == "Y"}
                        onChange={handleChange}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="currently_hospitalized"
                      >
                        Currently Hospitalized
                      </label>
                    </div>
                    <div className="custom-control custom-checkbox custom-control-inline mb-2">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="checkbox"
                        className="custom-control-input"
                        id="middle_of_treatment"
                        name="treatmentInd"
                        value="treatmentInd"
                        checked={state?.treatmentInd == "Y"}
                        onChange={handleChange}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="middle_of_treatment"
                      >
                        Middle of Treatment – Chemotherapy / Dialysis / Home
                        Health
                      </label>
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="custom-control custom-checkbox custom-control-inline mb-2">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="checkbox"
                        className="custom-control-input"
                        id="planned_surgery"
                        name="surgeryInd"
                        value="surgeryInd"
                        checked={state?.surgeryInd == "Y"}
                        onChange={handleChange}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="planned_surgery"
                      >
                        Planned Surgery in the coming months
                      </label>
                    </div>
                    <div className="custom-control custom-checkbox custom-control-inline mb-2">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="checkbox"
                        className="custom-control-input"
                        id="durable_medical_equipment"
                        name="equipmentInd"
                        value="equipmentInd"
                        checked={state?.equipmentInd == "Y"}
                        onChange={handleChange}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="durable_medical_equipment"
                      >
                        Durable Medical Equipment -
                      </label>

                      <span className="badge badge-pill ml-2 text-wrap-nowrap">
                        <div className="custom-control custom-checkbox custom-control-inline">
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="checkbox"
                            className="custom-control-input"
                            id="own"
                            name="equipmentType"
                            value="OWN"
                            disabled={state?.equipmentInd != "Y"}
                            checked={state?.equipmentType == "OWN"}
                            onChange={handleChange}
                          />
                          <label className="custom-control-label" htmlFor="own">
                            Own
                          </label>
                        </div>
                        <div className="custom-control custom-checkbox custom-control-inline">
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="checkbox"
                            className="custom-control-input"
                            id="rental"
                            name="equipmentType"
                            value="RENTAL"
                            disabled={state?.equipmentInd != "Y"}
                            checked={state?.equipmentType == "RENTAL"}
                            onChange={handleChange}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="rental"
                          >
                            Rental
                          </label>
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
              </fieldset>

              <fieldset className="fieldset-type1 form-inline w-100 mb-4">
                <legend class="list-group-item border-0">
                  If <strong>Rental, who is</strong> the DME Company?
                </legend>
                <div className="list-group-item border-0 w-100 mb-2">
                  <label className="label-type1">
                    Name:{" "}
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="text"
                      name="rentalCompanyName"
                      value={state?.rentalCompanyName}
                      onChange={handleChange}
                      className="form-control form-control-sm  mr-sm-2 input-name"
                    />
                  </label>
                  <label className="label-type1">
                    Phone:{" "}
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="text"
                      name="rentalCompanyPhone"
                      value={state?.rentalCompanyPhone}
                      onChange={handleChange}
                      maxLength="10"
                      className="form-control form-control-sm  mr-sm-2 input-name"
                    />
                  </label>
                </div>
                <div className="d-flex flex-wrap align-content-start ml-0 ml-md-2">
                  <span className="badge badge-pill">
                    <div className="custom-control custom-checkbox custom-control-inline">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="checkbox"
                        className="custom-control-input"
                        id="bath_chair"
                        name="rentalEquipments"
                        value="bath chair"
                        onChange={handleChange}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="bath_chair"
                      >
                        Bath Chair
                      </label>
                    </div>
                  </span>
                  <span className="badge badge-pill">
                    <div className="custom-control custom-checkbox custom-control-inline">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="checkbox"
                        className="custom-control-input"
                        id="commode"
                        name="rentalEquipments"
                        value="commode"
                        onChange={handleChange}
                      />
                      <label className="custom-control-label" htmlFor="commode">
                        Commode
                      </label>
                    </div>
                  </span>
                  <span className="badge badge-pill">
                    <div className="custom-control custom-checkbox custom-control-inline">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="checkbox"
                        className="custom-control-input"
                        id="hospital_bed"
                        name="rentalEquipments"
                        value="hospital bed"
                        onChange={handleChange}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="hospital_bed"
                      >
                        Hospital Bed
                      </label>
                    </div>
                  </span>
                  <span className="badge badge-pill">
                    <div className="custom-control custom-checkbox custom-control-inline">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="checkbox"
                        className="custom-control-input"
                        id="toilet_seats"
                        name="rentalEquipments"
                        value="toilet seats"
                        onChange={handleChange}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="toilet_seats"
                      >
                        Toilet seats
                      </label>
                    </div>
                  </span>
                  <span className="badge badge-pill">
                    <div className="custom-control custom-checkbox custom-control-inline">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="checkbox"
                        className="custom-control-input"
                        id="cane"
                        name="rentalEquipments"
                        value="cane"
                        onChange={handleChange}
                      />
                      <label className="custom-control-label" htmlFor="cane">
                        Cane
                      </label>
                    </div>
                  </span>
                  <span className="badge badge-pill">
                    <div className="custom-control custom-checkbox custom-control-inline">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="checkbox"
                        className="custom-control-input"
                        id="cpap_machine"
                        name="rentalEquipments"
                        value="cpap machine"
                        onChange={handleChange}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="cpap_machine"
                      >
                        CPAP machine
                      </label>
                    </div>
                  </span>
                  <span className="badge badge-pill">
                    <div className="custom-control custom-checkbox custom-control-inline">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="checkbox"
                        className="custom-control-input"
                        id="oxygen"
                        name="rentalEquipments"
                        value="oxygen"
                        onChange={handleChange}
                      />
                      <label className="custom-control-label" htmlFor="oxygen">
                        Oxygen
                      </label>
                    </div>
                  </span>
                  <span className="badge badge-pill">
                    <div className="custom-control custom-checkbox custom-control-inline">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="checkbox"
                        className="custom-control-input"
                        id="walker"
                        name="rentalEquipments"
                        value="walker"
                        onChange={handleChange}
                      />
                      <label className="custom-control-label" htmlFor="walker">
                        Walker
                      </label>
                    </div>
                  </span>
                  <span className="badge badge-pill">
                    <div className="custom-control custom-checkbox custom-control-inline">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="checkbox"
                        className="custom-control-input"
                        id="catheters"
                        name="rentalEquipments"
                        value="catheters"
                        onChange={handleChange}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="catheters"
                      >
                        Catheters
                      </label>
                    </div>
                  </span>
                  <span className="badge badge-pill">
                    <div className="custom-control custom-checkbox custom-control-inline">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="checkbox"
                        className="custom-control-input"
                        id="diapers"
                        name="rentalEquipments"
                        value="diapers"
                        onChange={handleChange}
                      />
                      <label className="custom-control-label" htmlFor="diapers">
                        Diapers
                      </label>
                    </div>
                  </span>
                  <span className="badge badge-pill">
                    <div className="custom-control custom-checkbox custom-control-inline mr-0">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="checkbox"
                        className="custom-control-input"
                        id="pressure_mattress"
                        name="rentalEquipments"
                        value="pressure mattress"
                        onChange={handleChange}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="pressure_mattress"
                      >
                        Pressure Mattress
                      </label>
                    </div>
                  </span>
                  <span className="badge badge-pill">
                    <div className="custom-control custom-checkbox custom-control-inline">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="checkbox"
                        className="custom-control-input"
                        id="wheelchair"
                        name="rentalEquipments"
                        value="wheelchair"
                        onChange={handleChange}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="wheelchair"
                      >
                        Wheelchair
                      </label>
                    </div>
                  </span>
                  <span className="badge badge-pill">
                    <div className="custom-control custom-checkbox custom-control-inline w-100 pl-3 pl-md-3">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="checkbox"
                        className="custom-control-input"
                        id="other2"
                        name="rentalEquipments"
                        value="other"
                        onChange={handleChange}
                      />
                      <label
                        className="custom-control-label ml-2 ml-md-0 pl-0"
                        htmlFor="other2"
                      >
                        Other
                      </label>
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="text"
                        className="form-control form-control-sm  mr-sm-2"
                        name="othEquipment1"
                        value={state?.othEquipment1}
                        onChange={handleChange}
                      />
                    </div>
                  </span>
                  {/* new */}
                  {/* <span className="badge badge-pill">
                    <div className="custom-control custom-checkbox custom-control-inline w-100 pl-3 pl-md-3">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="checkbox"
                        className="custom-control-input"
                        id="other3"
                        name="rentalEquipments"
                        value="other"
                        onChange={handleChange}
                      />
                      <label
                        className="custom-control-label ml-2 ml-md-0 pl-0"
                        htmlFor="other3"
                      >
                        Other
                      </label>
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="text"
                        className="form-control form-control-sm  mr-sm-2"
                        name="othEquipment2"
                        value={state?.othEquipment2}
                        onChange={handleChange}
                      />
                    </div>
                  </span> */}
                </div>
              </fieldset>
            </div>
          </div>
        </section>
        {/* <!-- Continuity Of Care and Services:end -->
       
       <!-- Medications:start --> */}
        <section>
          <h3 className="section-heading">Medications</h3>
          <div className="row mt-2">
            <div className="col-md-12">
              <fieldset className="fieldset-type1 form-inline w-100 mb-4">
                <legend>
                  Please provide a list of medications that require Prior
                  Authorization or not on our formulary, our Care Coordination
                  Team member will contact you to assist with the prescription
                  transition fills:
                </legend>
                <div className="list-group-item border-0 w-100 mb-2">
                  <div className="mb-3">
                    <label className="label-type1 mr-0 mr-md-5">
                      Medication Name:{" "}
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="text"
                        name="medicationName1"
                        value={state?.medicationName1}
                        onChange={handleChange}
                        className="form-control form-control-sm  mr-sm-2 input-name"
                      />
                    </label>
                    <label className="label-type1">
                      Dosage:{" "}
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="text"
                        name="dosage1"
                        value={state?.dosage1}
                        onChange={handleChange}
                        className="form-control form-control-sm  mr-sm-2 input-name"
                      />
                    </label>
                  </div>
                  <div className="mb-3">
                    <label className="label-type1 mr-0 mr-md-5">
                      Medication Name:{" "}
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="text"
                        name="medicationName2"
                        value={state?.medicationName2}
                        onChange={handleChange}
                        className="form-control form-control-sm  mr-sm-2 input-name"
                      />
                    </label>
                    <label className="label-type1">
                      Dosage:{" "}
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="text"
                        name="dosage2"
                        value={state?.dosage2}
                        onChange={handleChange}
                        className="form-control form-control-sm  mr-sm-2 input-name"
                      />
                    </label>
                  </div>
                  <div className="mb-3">
                    <label className="label-type1 mr-0 mr-md-5">
                      Medication Name:{" "}
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="text"
                        name="medicationName3"
                        value={state?.medicationName3}
                        onChange={handleChange}
                        className="form-control form-control-sm  mr-sm-2 input-name"
                      />
                    </label>
                    <label className="label-type1">
                      Dosage:{" "}
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="text"
                        name="dosage3"
                        value={state?.dosage3}
                        onChange={handleChange}
                        className="form-control form-control-sm  mr-sm-2 input-name"
                      />
                    </label>
                  </div>
                  <div className="mb-3">
                    <label className="label-type1 mr-0 mr-md-5">
                      Medication Name:{" "}
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="text"
                        name="medicationName4"
                        value={state?.medicationName4}
                        onChange={handleChange}
                        className="form-control form-control-sm  mr-sm-2 input-name"
                      />
                    </label>
                    <label className="label-type1">
                      Dosage:{" "}
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="text"
                        name="dosage4"
                        value={state?.dosage4}
                        onChange={handleChange}
                        className="form-control form-control-sm  mr-sm-2 input-name"
                      />
                    </label>
                  </div>
                  <div>
                    <label className="label-type1 mr-0 mr-md-5">
                      Medication Name:{" "}
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="text"
                        name="medicationName5"
                        value={state?.medicationName5}
                        onChange={handleChange}
                        className="form-control form-control-sm  mr-sm-2 input-name"
                      />
                    </label>
                    <label className="label-type1">
                      Dosage:{" "}
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="text"
                        name="dosage5"
                        value={state?.dosage5}
                        onChange={handleChange}
                        className="form-control form-control-sm  mr-sm-2 input-name"
                      />
                    </label>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
          <p className="col-md-12 text-danger">
            Please fill all mandatory fields marked as *{" "}
          </p>
        </section>
        {/* <!-- Medications:end --> */}
        <div className="mt-2 mb-2 text-center screen-only">
          <button
            type="submit"
            disabled={disable}
            className="btn btn-primary mr-3"
            onClick={submitHandler}
          >
            Submit
          </button>{" "}
          <button
            type="button"
            className="btn btn-outline-secondary mr-3"
            onClick={props.cancel}
          >
            Cancel
          </button>
        </div>
      </div>
    </main>
  );
};
